import React, {useEffect, useRef, useState} from 'react'
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon'
import EmojiPicker from 'emoji-picker-react'
import './Style/Components.scss'
import {WSSelect} from '../../_metronic/helpers/components/WSSelect/WSSelect'
import {toAbsoluteUrl, countWords} from '../../_metronic/helpers'
import WebLink from '../pages/UserPages/MyTemplate/CreateScratch/WebLink'
import {useDispatch, useSelector} from 'react-redux'
import {getOurTemplateList} from '../pages/UserPages/MyTemplate/OurTemplates/OurTemplateSlice/OurTemplateSlice'
import {
  getAllTemplateWithoutPagination,
  getTemplateList,
  getTemplateListWithoutPagination,
} from '../pages/UserPages/MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import {confirm} from 'react-confirm-box'
import {AuthenticateUser} from '../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import {processData, replaceMessageWith} from '../Utils/_helpers'
import {ENV} from '../Utils/_helpers/EnvHelper'
import {BulkMsgDraftData} from '../pages/UserPages/new-message/BulkMessageSlice/BulkMessageSlice'
import {GLOBAL_SETTINGS_TYPE} from '../Utils/Constant/ConstantForWebsite'
import {base64ToBlob, blobToFile} from '../Utils/file'
import WebLinkSecond from '../pages/UserPages/MyTemplate/CreateScratch/WebLinkSecond'
import { getDefaultOptOutUrl } from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

const MessageBoxSecond = ({
  setUserMessage,
  userMessage,
  selectedFile,
  itQuickMessage,
  quickSms,
  disableTextfield,
  setError,
  error,
  isInbox,
  isTemplate,
  showSelect,
  isRMSChat = false,
  onlyStop = false,
  isAlphaId = false,
  isDraft = false,
  containerStyle = {},
}: any) => {
  const dispatch = useDispatch()
  const inputRef: any = useRef()
  const pickerRef: any = useRef(null)
  const [popup, setPopup] = useState(false)
  const CustomFieldName: any = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )
  const [showMore, setShowMore] = useState(false)

  const conditionData =
    userMessage?.senderType == 'businessName' || userMessage?.senderType == 'customNumber'

  const optOutBaseUrl = useSelector(getDefaultOptOutUrl)

  let optoutList = useSelector((state: any) => {
    const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []

    if (quickSms) {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        itQuickMessage
          ? GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
          : GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
      )

      list = isDisableReplyByGlobalOption ? list : []
    }

    if (!quickSms) {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        itQuickMessage
          ? GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
          : GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    if (onlyStop) {
      return []
    }

    return list
  })
  const LandingPageList = useSelector((state: any) => state?.LandingPage?.landingPage?.data)

  // const templates: any = useSelector(getTemplateList)
  const templates: any = useSelector(getTemplateListWithoutPagination)
  const [showPicker, setShowPicker] = useState(false)
  const [webLinkDataToEdit, setWebLinkDataToEdit] = useState({longUrl: '', shortUrl: ''})

  const [options, setOptions] = useState({
    webLink: [
      {
        value: 'create',
        label: 'Create..',
        // label: (
        //   <button
        //     disabled={userMessage?.longUrl?.length >= 4}
        //     onClick={(e: any) => {
        //       e.preventDefault()
        //       setPopup(true)
        //       setWebLinkDataToEdit({longUrl: '', shortUrl: ''})
        //     }}
        //   >
        //     Create New
        //   </button>
        // ),
      },
    ],

    optOut: [{value: 'ReplyStop', label: `Reply 'Stop' to opt out`, isDisabled: conditionData}],
  })

  useEffect(() => {
    const handleOutsideClick = (e: any) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])
  useEffect(() => {
    AuthenticateUser('templates-list') && dispatch(getAllTemplateWithoutPagination())
  }, [])
  const optOut = [
    // {
    //   value: '',
    //   label: `${
    //     userMessage?.replyStopToOptOut ? " Reply 'Stop' to opt-out" : 'STOP:{stoptxt.cc/}'
    //   }`,
    //   isDisabled: false,
    // },
    // {value: 'ReplyStop', label: `Reply 'Stop' to opt out`, isDisabled: conditionData},
  ]
  let data =
    CustomFieldName?.length > 0
      ? CustomFieldName?.map((key: any) => {
          return {value: `{{[${key}]}}`, label: `${key}`}
        })
      : []
  const LandingPages =
    LandingPageList?.length > 0
      ? LandingPageList?.map((key: any) => {
          return {
            value: `${key?._id}`,
            label: `${key?.campaignName}`,
          }
        })
      : []

  const CustomOptOutList =
    optoutList?.length > 0
      ? optoutList?.map((key: any) => {
          return {
            value: `${key?._id}`,
            label: `${key?.title}`,
          }
        })
      : []

  const Templates =
    templates?.length > 0
      ? templates
          ?.filter((key: any) => key?.type?.toUpperCase() == userMessage?.camp_type?.toUpperCase())
          ?.map((key: any) => {
            return {
              value: `${key?.name}`,
              label: `${key?.name}`,
            }
          })
      : []

  const handleChange = (e: any) => {
    if (e.label) {
      let errorData = {...error}

      delete errorData.messageSecond
      setError(errorData)
      let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current.selectionStart)
      let endSubString = userMessage?.messageSecond?.slice(inputRef.current.selectionEnd)
      let content = startSubString + e.value + ' ' + endSubString

      setUserMessage({...userMessage, messageSecond: content})

      if (isDraft) {
        dispatch(BulkMsgDraftData({...userMessage, scheduledAtSecond: '', messageSecond: content}))
      }
      inputRef?.current.focus()
    } else {
      let errorData = {...error}

      delete errorData.message
      e.target.value !== ''
        ? setError(errorData)
        : setError({...error, messageSecond: 'Message is required'})

      setUserMessage({
        ...userMessage,
        [e.target.name]: e.target.value,
      })
      if (isDraft) {
        dispatch(
          BulkMsgDraftData({...userMessage, scheduledAtSecond: '', [e.target.name]: e.target.value})
        )
      }
    }
  }

  // landing page
  const handleChangeLandingPage = (e: any) => {
    let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current.selectionStart)
    let endSubString = userMessage?.messageSecond?.slice(inputRef.current.selectionEnd)

    if (e.value !== '') {
      let content = startSubString + `${ENV().REACT_APP_SHORTURL}/Lxxxxx` + ' ' + endSubString
      setUserMessage({...userMessage, messageSecond: content, landingPageIdSecond: e.value})
      if (isDraft) {
        dispatch(
          BulkMsgDraftData({
            ...userMessage,
            scheduledAtSecond: '',
            messageSecond: content,
            landingPageIdSsecond: e.value,
          })
        )
      }
      inputRef?.current.focus()
    }
  }
  // weblink
  const handleWeblinkData = (e: any) => {
    if (e?.value == 'create') {
      setPopup(true)
      setWebLinkDataToEdit({longUrl: '', shortUrl: ''})
    } else {
      setPopup(true)
      const webLinkData = userMessage?.longUrlSecond ?? []
      const findData = webLinkData.find((data: any) => data?.shortUrl == e?.value) ?? {
        longUrl: '',
        shortUrl: '',
      }
      setWebLinkDataToEdit({longUrl: findData?.longUrl, shortUrl: findData?.shortUrl})
    }
  }

  // optout
  const handleOptout = (e: any) => {
    if (e?.value !== '') {
      if (userMessage?.senderType == 'businessName' || userMessage?.senderType == 'customNumber') {
        if (e.value !== 'ReplyStop') {
          setUserMessage({
            ...userMessage,
            replyStopToOptOutSecond: false,
            optoutSecond: true,
            optoutIdSecond: e.value,
            optoutLabelSecond: e.label,
          })
        }

        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAtSecond: '',
              replyStopToOptOutSecond: false,
              optoutSecond: true,
              optoutIdSecond: e.value,
              optoutLabelSecond: e.label,
            })
          )
        }
      } else {
        if (e.value == 'ReplyStop') {
          setUserMessage({
            ...userMessage,
            replyStopToOptOutSecond: true,
            optoutSecond: false,
            optoutIdSecond: '',
          })
          if (isDraft) {
            dispatch(
              BulkMsgDraftData({
                ...userMessage,
                scheduledAtSecond: '',
                optoutIdSecond: '',
                replyStopToOptOutSecond: true,
                optoutSecond: false,
              })
            )
          }
        } else {
          setUserMessage({
            ...userMessage,
            scheduledAtSecond: '',
            replyStopToOptOutSecond: false,
            optoutSecond: true,
            optoutIdSecond: e.value,
            optoutLabelSecond: e.label,
          })

          if (isDraft) {
            dispatch(
              BulkMsgDraftData({
                ...userMessage,
                scheduledAtSecond: '',
                replyStopToOptOutSecond: false,
                optoutSecond: true,
                optoutIdSecond: e.value,
                optoutLabelSecond: e.label,
              })
            )
          }
        }
      }
    } else {
      if (
        e.value == 'ReplyStop' &&
        userMessage?.senderType !== 'businessName' &&
        userMessage?.senderType !== 'customNumber'
      ) {
        setUserMessage({
          ...userMessage,
          replyStopToOptOutSecond: true,
          optoutSecond: false,
          optoutIdSecond: '',
        })

        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAtSecond: '',
              replyStopToOptOutSecond: true,
              optoutSecond: false,
              optoutIdSecond: '',
            })
          )
        }
      } else {
        setUserMessage({
          ...userMessage,
          replyStopToOptOutSecond: false,
          optoutSecond: true,
          optoutIdSecond: e.value,
          optoutLabelSecond: e.label,
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAtSecond: '',
              replyStopToOptOutSecond: false,
              optoutSecond: true,
              optoutIdSecond: e.value,
              optoutLabelSecond: e.label,
            })
          )
        }
      }
    }
  }

  // emoji
  const onEmojiClick = (event: any) => {
    let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current.selectionStart)
    let endSubString = userMessage?.messageSecond?.slice(inputRef.current.selectionEnd)
    let content = startSubString + event.emoji + endSubString
    setUserMessage({...userMessage, messageSecond: content})

    if (isDraft) {
      dispatch(
        BulkMsgDraftData({
          ...userMessage,
          scheduledAtSecond: '',
          messageSecond: content,
        })
      )
    }
    setShowPicker(false)
    inputRef?.current.focus()
  }
  const optionsWithLabelChange: any = {
    closeOnOverlayClick: false,
    labels: {
      confirmable: 'Yes',
      cancellable: 'No',
    },
  }

  const containsEmoji = (str: string) => {
    const unicodeRegex = /[^\u0000-\u007F]/ // Matches non-ASCII characters (Unicode)
    const emojiRegex = /(\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\p{Extended_Pictographic})/u // Matches emojis
    return unicodeRegex.test(str) || emojiRegex.test(str)
  }

  // template
  const handleTemplate = async (event: any) => {
    const confirmation = await confirm(
      `Are you sure you want to use this ${event?.value} template`,
      optionsWithLabelChange
    )
    if (confirmation) {
      if (event?.value !== '') {
        if (userMessage?.camp_type == 'sms') {
          let startSubString = userMessage?.messageSecond?.slice(0, inputRef.current.selectionStart)
          let endSubString = userMessage?.messageSecond?.slice(inputRef.current.selectionEnd)
          let data = templates?.find((key: any) => key?.name === event?.value)
          if (data && data.longUrl && Array.isArray(data.longUrl)) {
            let longUrl = [...data.longUrl]
            let filteredLongUrl = longUrl.filter((item: any) => typeof item !== 'string')
            data = {...data, longUrl: filteredLongUrl}
          }

          // replace all optout message
          const messageSecond = replaceMessageWith(data?.message, '')
          let newPayload = {
            ...userMessage,
            messageSecond,
            longUrlSecond: data?.longUrl ?? undefined,
          }

          if (data?.optout && data.optout === true && data?.optoutId && data.optoutId !== '') {
            const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
            if (optOutData) {
              newPayload.optoutLabelSecond = optOutData.title
            }

            newPayload.optoutSecond = data.optout
            newPayload.optoutIdSecond = data.optoutId
            newPayload.replyStopToOptOutSecond = false
          } else {
            newPayload.optoutSecond = false
            newPayload.optoutIdSecond = ''

            if (optoutList.length > 0) {
              newPayload.replyStopToOptOutSecond = true
            }
          }

          if (
            data?.landingPage &&
            data.landingPage === true &&
            data?.landingPageId &&
            data.landingPageId !== ''
          ) {
            newPayload.landingPageSecond = data.landingPage
            newPayload.landingPageIdSecond = data.landingPageId
          }

          setUserMessage(newPayload)
          if (isDraft) {
            dispatch(BulkMsgDraftData({...newPayload, scheduledAtSecond: ''}))
          }
          inputRef?.current.focus()
        } else {
          let startSubString = userMessage?.message?.slice(0, inputRef.current.selectionStart)
          let endSubString = userMessage?.message?.slice(inputRef.current.selectionEnd)
          let messageData = replaceMessageWith(
            templates?.find((key: any) => key?.name === event?.value)?.message,
            ''
          )
          let data = templates?.find((key: any) => key?.name === event?.value)
          if (data && data.longUrl && Array.isArray(data.longUrl)) {
            let longUrl = [...data.longUrl]
            let filteredLongUrl = longUrl.filter((item: any) => typeof item !== 'string')
            data = {...data, longUrl: filteredLongUrl}
          }

          if (data?.media !== '') {
            let newPayload = {
              ...userMessage,
              message: messageData,
              media: data?.media,
              mediaType: data?.mediaType,
              urlData: {
                fileName: `${Date.now()}.jpg`,
                filetype: data?.mediaType,
                mediaType: data?.mediaType,
                url: data?.media,
              },
              subject: data?.subjectTitle,
              longUrl: data?.longUrl ?? undefined,
            }

            if (data?.base64media) {
              const fileName = data?.media.split('/').pop()
              const blob = base64ToBlob(data?.base64media, data?.mediaType)
              const file = blobToFile(blob, fileName)
              newPayload.media = file
            }

            if (data?.optout && data.optout === true && data?.optoutId && data.optoutId !== '') {
              const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
              if (optOutData) {
                newPayload.optoutLabel = optOutData.title
              }

              newPayload.optout = data.optout
              newPayload.optoutId = data.optoutId
              newPayload.replyStopToOptOut = false
            } else {
              newPayload.optout = false
              newPayload.optoutId = ''

              if (optoutList.length > 0) {
                newPayload.replyStopToOptOut = true
              }
            }

            if (
              data?.landingPage &&
              data.landingPage === true &&
              data?.landingPageId &&
              data.landingPageId !== ''
            ) {
              newPayload.landingPage = data.landingPage
              newPayload.landingPageId = data.landingPageId
            }

            setUserMessage(newPayload)
            if (isDraft) {
              dispatch(BulkMsgDraftData({...newPayload, scheduledAtSecond: ''}))
            }
          } else {
            let newPayload = {
              ...userMessage,
              messageSecond: messageData,
              gif: data?.gif,
              mediaType: data?.mediaType,
              subject: data?.subjectTitle,
              longUrl: data?.longUrl ?? undefined,
            }
            if (data?.optout && data.optout === true && data?.optoutId && data.optoutId !== '') {
              const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
              if (optOutData) {
                newPayload.optoutLabelSecond = optOutData.title
              }

              newPayload.optoutSecond = data.optout
              newPayload.optoutIdSecond = data.optoutId
              newPayload.replyStopToOptOutSecond = false
            } else {
              newPayload.optoutSecond = false
              newPayload.optoutIdSecond = ''
              if (optoutList.length > 0) {
                newPayload.replyStopToOptOutSecond = true
              }
            }

            if (
              data?.landingPage &&
              data.landingPage === true &&
              data?.landingPageId &&
              data.landingPageId !== ''
            ) {
              newPayload.landingPageSecond = data.landingPage
              newPayload.landingPageIdSecond = data.landingPageId
            }

            setUserMessage(newPayload)
            if (isDraft) {
              dispatch(BulkMsgDraftData({...newPayload, scheduledAtSecond: ''}))
            }
          }

          inputRef?.current.focus()
        }
      }
    }
  }

  const optoutCount = userMessage?.optoutSecond === true ? 22 : 0
  const replyStopToOptOutCount = userMessage?.replyStopToOptOutSecond === true ? 15 : 0
  const webLinkOptions = userMessage?.longUrlSecond
    ? userMessage?.longUrlSecond?.map((key: any) => ({
        value: key?.shortUrl,
        label: key?.shortUrl,
      }))
    : []

  let textMessage = userMessage?.messageSecond

  if (optoutList.length > 0) {
    if (userMessage?.optoutSecond) {
      textMessage = replaceMessageWith(textMessage, `\n\nSTOP: ${optOutBaseUrl}/vc`)
    }
    if (userMessage?.replyStopToOptOutSecond && optoutList.length > 0) {
      textMessage = replaceMessageWith(textMessage, "\n\nReply 'STOP' to opt-out")
    }
  }

  return (
    <div style={{...containerStyle}}>
      <WebLinkSecond
        data={webLinkDataToEdit}
        inputRef={inputRef}
        show={popup}
        handleClose={() => setPopup(false)}
        setBulkMessageData={setUserMessage}
        bulkMessageData={userMessage}
      />
      <div>
        <div className='mt-0 mb-7 col-12 message-wrapbox create-scratch-sms'>
          <label className='form-label'>Message {userMessage?.abTest ? 'B' : null}</label>
          <div className='message-row row p-1 py-0 px-6 gy-0 gx-0 d-flex'>
            <div className='message-col  border-right-1'>
              <div className='selectbox' data-testid='ddCustomField2'>
                <img
                  className='imgpos'
                  src={toAbsoluteUrl('/media/mobile/Custom-field.svg')}
                  alt='img'
                  data-testid='iconCustomField2'
                />
                <Select
                  isSearchable={false}
                  value={{value: '', label: 'Custom Field'}}
                  onChange={(e: any) => {
                    handleChange(e)
                  }}
                  options={[...data]}
                  name='message'
                  className={`common-select`}
                  placeholder='Custom Field'
                />
              </div>
            </div>
            {showSelect?.includes('template') && (
              <div className='message-col border-right-1'>
                <div className='selectbox' data-testId='ddTemplates2'>
                  <img
                    className='imgpos'
                    src={toAbsoluteUrl('/media/mobile/web-link.svg')}
                    alt='img'
                    data-testid='iconTemplate2'
                  />
                  <Select
                    isSearchable={false}
                    value={{value: '', label: 'Template'}}
                    onChange={(e: any) => {
                      handleTemplate(e)
                    }}
                    options={[...Templates]}
                    name='message'
                    className={`common-select`}
                    placeholder='Templates'
                  />
                </div>
              </div>
            )}
            {showSelect?.includes('weblink') && (
              <div className='message-col border-right-1'>
                <div className='selectbox' data-testId='ddShortUrl2'>
                  <img
                    className='imgpos'
                    src={toAbsoluteUrl('/media/mobile/web-link.svg')}
                    alt='img'
                    data-testid='iconShortUrl2'
                  />
                  <Select
                    isSearchable={false}
                    value={{value: '', label: 'Short URL'}}
                    onChange={(e: any) => {
                      handleWeblinkData(e)
                    }}
                    options={[...options.webLink, ...webLinkOptions]}
                    name='message'
                    className={`common-select `}
                    placeholder='Short URL'
                  />
                </div>
              </div>
            )}

            {showSelect?.includes('landingPage') && (
              <div className='message-col border-right-1'>
                <div className='selectbox selectname' data-testId='ddLandingPage2'>
                  <img
                    className='imgpos'
                    src={toAbsoluteUrl('/media/mobile/Landing-page.svg')}
                    alt='img'
                    data-testid='iconLandingPage2'
                  />
                  <Select
                    isSearchable={false}
                    onChange={(e: any) => {
                      handleChangeLandingPage(e)
                    }}
                    value={{value: '', label: 'Landing page'}}
                    options={[...LandingPages]}
                    name='message'
                    className={`common-select `}
                    placeholder='Custom-LandingPage'
                  />
                </div>
              </div>
            )}
            <div className='message-col last-col border-right-1 d-flex align-items-center justify-content-end'>
              <InsertEmoticonIcon onClick={() => setShowPicker((val) => !val)} />
            </div>
            {showPicker && (
              <div ref={pickerRef}>
                <EmojiPicker onEmojiClick={onEmojiClick} />
              </div>
            )}
          </div>

          <textarea
            disabled={disableTextfield}
            maxLength={quickSms !== true ? 1000 : 1224 - (replyStopToOptOutCount + optoutCount)}
            className='form-control form-control-solid border-top border-bottom border-right-0 border-left-0 rounded-0'
            rows={5}
            ref={inputRef}
            value={textMessage}
            data-kt-element='input'
            data-testId='inputSecondMessage'
            placeholder='Enter your message here...'
            name='messageSecond'
            onChange={handleChange}
          ></textarea>

          <div className='d-flex justify-content-end text-end mb-3'>
            <span className='form-control form-control-solid d-flex align-items-center justify-content-between text-end bottom-controls'>
              <div className='message-col border-right-1'>
                <div className='selectbox d-flex align-items-center '>
                  {CustomOptOutList.length > 0 && showSelect?.includes('opt-out') && (
                    <div className='' style={{width: '100%'}} data-testId='ddOptOut2'>
                      <Select
                        isSearchable={false}
                        menuPlacement='auto'
                        value={
                          userMessage?.replyStopToOptOutSecond
                            ? {value: '', label: " Reply 'STOP' to opt-out"}
                            : {
                                value: '',
                                label: `STOP:{${optOutBaseUrl}/${userMessage?.optoutLabelSecond ?? ''}}`,
                              }
                        }
                        onChange={(e) => {
                          handleOptout(e)
                        }}
                        options={[
                          {value: 'ReplyStop', label: "Reply 'STOP' to opt-out"},
                          ...CustomOptOutList,
                        ].filter((it) => {
                          if (['businessName', 'customNumber'].includes(userMessage?.senderType)) {
                            return it.value !== 'ReplyStop'
                          } else {
                            return true
                          }
                        })}
                        name='optout'
                        className=''
                        placeholder={
                          userMessage?.replyStopToOptOutSecond
                            ? ` Reply 'STOP' to opt-out`
                            : 'STOP:{stoptxt.cc/}'
                        }
                      />
                    </div>
                  )}

                  {CustomOptOutList.length > 0 && showSelect?.includes('opt-out') && (
                    <i
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      title={`STOP link:{${optOutBaseUrl}/Links Name}`}
                      className='bi bi-question-circle-fill px-3 '
                    ></i>
                  )}
                </div>
              </div>
              {isRMSChat ? (
                <span>Rich Messaging</span>
              ) : (
                <div>
                  <span className='text-danger'>
                    {quickSms !== true
                      ? `1 MMS  Credit  ${countWords(userMessage?.messageSecond)}/1000`
                      : `${
                          processData(userMessage?.messageSecond ?? '', 0, isAlphaId)?.length
                        } character remaining / ${
                          processData(userMessage?.messageSecond ?? '', 0, isAlphaId)?.maxdata
                        }`}
                  </span>
                  {quickSms === true && (
                    <span className='bg-primary text-white p-1 mx-1'>
                      <b>
                        {' '}
                        ({processData(userMessage?.messageSecond ?? '', 0, isAlphaId)?.credit} SMS
                        Used)
                      </b>
                    </span>
                  )}
                </div>
              )}
            </span>
          </div>

          {containsEmoji(textMessage) && (
            <span>Special characters and emojis use multiple character spaces per message</span>
          )}
        </div>
      </div>
    </div>
  )
}

export default MessageBoxSecond
